export default {
    "lang": "中文(繁体)",
    application: {
        name: '資訊發布系統',
    },
    ajaxTip: {
        success: '成功',
        error: '失敗',
        noAccess: '無權訪問此資源',
        notFound: '訪問資源不存在',
        serverBusy: '伺服器繁忙',
        timeOut: '逾時',
    },
    menu: {
        home: '首頁',
        template: '模板管理',
        program: '節目管理',
        playplan: '播放計畫',
        device: '設備管理',
        "source-material": '素材管理',
        material: '素材',
        checkManage: '審核管理',
        setting: '設定',
        usercenter: "用戶中心",
        adminManage: "設備管理",
        schedule: "待辦事項",
        capitalassets: "資產管理",
        modifyPassword: '修改密碼',
        logout: '退出登入',
        "add": "新增",
        "edit": "編輯",
        "delete": "刪除",
        "view": "檢視",
        "menu_1": "首頁",
        "menu_2": "設備管理",
        "menu_3": "編輯(高階設定-一般編輯-更換網路)",
        "menu_4": "即時指令",
        "menu_5": "編輯(轉移部門)",
        "menu_6": "策略",
        "menu_7": "音量設定",
        "menu_8": "亮度設定",
        "menu_9": "下載設定",
        "menu_10": "休眠設定",
        "menu_11": "設備屬性",
        "menu_12": "編輯/新增",
        "menu_13": "節目管理",
        "menu_14": "發布歷史",
        "menu_15": "刪除（批次/單個）",
        "menu_16": "發布中的節目",
        "menu_17": "分組",
        "menu_19": "節目列表",
        "menu_20": "內容編輯",
        "menu_21": "節目複製",
        "menu_23": "節目發布",
        "menu_24": "素材管理",
        "menu_25": "上傳",
        "menu_28": "快速發布",
        "menu_29": "範本管理",
        "menu_30": "公共範本",
        "menu_31": "立即使用",
        "menu_32": "我的範本",
        "menu_33": "發布至公共範本",
        "menu_35": "共享紀錄",
        "menu_36": "審核管理",
        "menu_37": "節目審核",
        "menu_38": "審核（通過/拒絕）",
        "menu_39": "素材審核",
        "menu_41": "審核歷史（操作員）",
        "menu_42": "審核歷史（審核員）",
        "menu_43": "審批數量查詢",
        "menu_44": "組織管理",
        "menu_45": "日誌管理",
        "menu_46": "播放日誌",
        "menu_47": "發布日誌",
        "menu_48": "錯誤日誌",
        "menu_49": "操作日誌",
        "menu_50": "文件日誌",
        "menu_51": "登入日誌",
        "menu_52": "內容審批",
        "menu_53": "儲存空間",
        "menu_54": "組織架構",
        "menu_55": "角色權限",
        "menu_56": "授權",
        "menu_57": "查看(授權權限)",
        "menu_58": "組織成員",
        "menu_60": "重置下級用戶密碼",
        "menu_61": "資產管理",
        "menu_62": "我的餘額",
        "menu_63": "查看(資金明細)",
        "menu_64": "我的流量",
        "menu_65": "查看(流量明細)",
        "menu_66": "購買流量",
        "menu_67": "我的容量",
        "menu_68": "我的設備",
        "menu_69": "訂單明細",
        "menu_70": "查看(充值)",
        "menu_71": "查看(購買範本)",
        "menu_72": "查看(購買流量)",
        "menu_73": "其他權限",
        "menu_74": "查看(素材節目統計)",
        "menu_75": "查看(資產)",
        "menu_76": "查看(雲流量/統計)",
        "menu_77": "查看(設備在線統計)"
    },
    login: {
        terminalServiceSystem: '智慧終端服務系統',
        accountLogin: '帳號登入',
        register: '註冊',
        accountLoginTip: '已有帳號登入',
        scanQRCode: '請掃描二維碼',
        readAndAgree: '我已閱讀並同意',
        readAndAgreeLink: '用戶服務協議',
        readAndAgreeAgreement: '請閱讀並同意用戶服務協議',
        forgetpassword: "忘記密碼？",
        resetpassword: "重設密碼",
        phoneEmptyTip: "請輸入手機號",
        nextStep: "下一步",
        title: '歡迎登入',
        submit: '登入',
        userName: '帳號',
        password: '密碼',
        userNameEmptyTip: '請輸入帳號',
        passwordEmptyTip: '請輸入密碼',
        passwordFormatTip: '請輸入正確的密碼格式',
        passwordIsOk: '請輸入確認密碼',
        passwordSign: '請輸入密碼',
        codeTip: "請輸入驗證碼",
        phone: "手機號不能為空",
        code: "驗證碼不能為空",
        nickname: "公司名稱不能為空",
        pass: "密碼不能為空",
        pwdMessage: "密碼長度8~20字元，不能包含空格且必須包含大小寫字母、數字、特殊字元其中3種",
        pwdMessage01: "請輸入密碼字母加數字八位以上",
        pwdMessage02: "密碼長度8-20個字元",
        pwdMessage03: "密碼不能包含空格",
        pwdMessage04: "密碼必須包含大寫字母、小寫字母、數字、符號其中三種",
        newpassempty: "新密碼不能為空",
        newpass: "兩次密碼不一致",
        getcode: "取得驗證碼",
        format: "手機號格式不正確",
        chongfa: "秒後重新發送",
        isSend: '已發送',
        noregister: "沒有帳號？立即註冊",
        Mobile: "手機號",
        verificationcode: "驗證碼",
        petname: "暱稱",
        Quickregistration: "快速註冊",
        xiugaimima: "修改密碼",
        jiumima: "舊密碼",
        xinmima: "新密碼",
        zaicishuruxinmima: "再次輸入新密碼",
        xiugaichenggong: "修改成功",
        xiugaishoujihao: "修改手機號",
        dengluzhanghao: "登入帳號",
        gongsiid: "公司id",
        yonghunicheng: "用戶暱稱",
        chuangjianshijian: "建立時間",
        gongsimingcheng: "公司名稱",
        denglumima: "登入密碼",
        jianyi: "建議使用字母數字組合的密碼",
        shezhimima: "設定密碼",
        shezhishoujihao: "修改/設定手機號",
        yibangding: "已綁定",
        weibangding: "未綁定",
        zhanghuanquan: "帳戶安全",
        yonghuxinxi: "用戶資訊",
        zhuceSucMsg: '恭喜您,註冊成功!',
        verificationcodeSucMsg: "驗證碼發送成功！",
        requiredIsEmpty: "必填項不能為空！",
        emailObj: {
            title: '信箱',
            tit: '信箱登入',
            tip: '請輸入信箱地址',
            formatTip: '請輸入正確的信箱格式',
        },
        phoneObj: {
            title: '手機',
            tit: '手機登入',
            tip: '請輸入手機號',
            formatTip: '請輸入正確的手機號格式',
        },
        emailOrPhoneObj: {
            title: '信箱或手機號',
            tit: '信箱或手機號登入',
            tip: '請輸入信箱或手機號',
            formatTip: '請輸入正確的信箱或手機號格式',
        },
        wechatObj: {
            title: '微信',
            tit: '微信登入',
        },
        googleObj: {
            title: '谷歌',
            tit: '谷歌登入',
        },
        confirm: '確定',
        confirmSubmit: '確定提交',
        cancel: '取消',
        close: '關閉',
        bindSucMsg: '綁定成功',
        toContinueBindAccount: '繼續以完成第三方帳號綁定',
        bindTip01: '沒有帳號？註冊一個',
        bindTip02: '已有帳號',
        bindTip03: '當前第三方帳號未綁定平台帳號，請綁定已有帳號或註冊綁定新帳號，下次即可快速登入。',
        bindTip04: '綁定已有帳號',
        bindTip05: '註冊綁定新帳號',
        bindTip06: '你已通過第三方授權，完善以下登入資訊即可完成綁定',
        bindSubmit: '提交綁定',
        enterAccountTip: '請輸入帳戶名稱',
        RegisterAndBind: '註冊並綁定',
        loginErr: '用戶名或密碼錯誤！',
        "usercenter": "使用者中心",
        "pleaseInputName": "請輸入名稱",
        "operationSuccess": "操作成功！",
        "edit": "編輯",
        "xiugai": "修改",
        "userData": "個人資料",
        "changePassword": "密碼修改",
        "account": "帳號",
        "userName01": "使用者名稱",
        "phoneNumber": "手機號",
        "role": "角色",
        "createTime": "建立時間",
        "genghuang": "更換",
        "bangding": "綁定",
        "unbind": "解除綁定",
        "plesaseSelectBindingType": "請選擇綁定類型",
        "pleaseConfirmCont": "請確認我已閱讀此內容",
        "confirmReadCont": "我已閱讀此內容",
        "frequentTip": "操作過於頻繁，請稍後再獲取！",
        "zhuxiaoBtn": "註銷帳號",
        "zhuxiaoTitle": "帳號註銷",
        "querenZhuxiao": "確定註銷",
        "jiXu": "繼續",
        "sendCodeBtn": "發送驗證碼",
        "passwordIsNotOldPassword": "確認密碼與新密碼輸入不一致",
        "passwordIsOldPassword": "修改密碼與原密碼相同",
        "passFormatError": "請輸入正確的密碼格式",
        "oldPassWord": "原密碼",
        "newPassWord": "新密碼",
        "inputPlaceholder": "請輸入",
        "confirmPassword": "確認密碼",
        "zhuxiaoTip": `
                1、註銷帳號為不可復原操作，帳號一旦註銷，您將無法再登入及使用本帳號或透過本帳號註冊登入的第三方帳號，請自行備份帳號相關資訊及數據。
                2、本帳號註銷前，請您務必確認已清空全部資產且不存在任何爭議；本帳號一經註銷，即視為您放棄對本帳號內的全部資產及權益的所有權，且無法復原或找回。
                3、同一手機號註冊的帳號累計註銷滿3次的，該手機號將無法再次註冊新帳號，同時亦無法綁定任何其他帳號。
        `
    },
    home: {
        title: "首頁",
        quickOperation: "快捷操作",
        addDevice: "新增設備",
        publishProgram: "發布節目",
        publishMaterial: "發布素材",
        makeProgram: "製作節目",
        uploadMaterial: "上傳素材",
        todayData: "今日數據（每小時更新）",
        playNumChart: "播放次數統計",
        deviceOnlineStatus: "設備線上狀況",
        onLineDevice: "線上設備",
        unLineDevice: "離線設備",
        programPlayTime: "節目播放時長統計",
        downloadSoft: "軟體下載",
        adminApp: "手機用戶端",
        playerApp: "信發播放終端",
        downloadAdminApp: "點擊下載用戶端",
        downloadPlayerApp: "點擊下載播放端",
        aboutUs: "關於我們",
        userManual: "用戶手冊",
        message: "我要留言",
    },
    device: {
        inputPlaceholder: '請輸入',
        selectPlaceholder: '請選擇',
        osTypeStr: '終端系統',
        onLineStatus: '線上狀態',
        dpi: '解析度',
        companyDeptIdName: '所屬機構',
        deviceGroupIdName: '所屬分組',
        editOrMove: '編輯/移動',
        loanOriginationFee: '貸款手續費',
        strategyInfoLook: '策略資訊查看',
        programLook: '節目查看',
        addEquipments: '新增設備',
        luminanceSet: '亮度控制',
        terminal: '終端設定',
        transferCompany: '轉移部門',
        releasedProgram: '發布節目',
        screenshot: '截圖',
        changeGroup: '更改分組',
        defaultGroup: "預設分組",
        operation: "操作",
        edit: "編輯",
        saveEdit: "儲存編輯",
        add: "新增",
        save: "儲存",
        setting: "設定",
        program: "節目",
        unbind: "解除綁定",
        sleep: "休眠",
        wakeup: "喚醒",
        restart: "重新啟動",
        shutdown: "關機",
        reportLog: "上報日誌",
        clearPlayData: "清除播放端數據",
        offlineWarn: "該設備已離線，設備線上後請重試！",
        confirmUnbind: "確定解除綁定",
        confirmReset: "確定清除",
        confirmDelete: "確定刪除",
        delete: "刪除",
        cancelDelete: "取消刪除",
        confirmResetSuccess: "清除成功",
        confirm: "確定",
        cancel: "取消",
        operationSuccess: "操作成功",
        unbindSuccess: "解除綁定成功",
        pleaseSelectDevice: "請選擇設備",
        pleaseSelectOnlineDevice: "請選擇線上設備",
        confirmMixOperation: "所選設備中包含離線設備，該設定對離線設備不生效，確認繼續操作？",
        pleaseSelectDate: "請選擇日期",
        reportSuccess: "上報成功",
        deviceSetting: "設備設定",
        default: "預設",
        all: "全部",
        deviceList: "設備列表",
        addDevice: "新增設備",
        department: "部門機構",
        deviceType: "解析度",
        osType: "終端系統",
        onlineState: "線上狀態",
        online: "線上",
        offline: "離線",
        notActive: "未啟用",
        search: "請輸入關鍵字",
        batchOperation: "批次操作",
        allDevices: "全部設備",
        deviceAttribute: "設備屬性",
        selectReportDate: "選擇上報日期",
        inputName: "請輸入名稱",
        inputWidth: "請輸入寬度",
        inputHeight: "請輸入高度",
        inputResolutionRatio: "請輸入大於0的整數！",
        inputSort: "請輸入排序",
        serialNum: "序號",
        name: "名稱",
        width: "寬度",
        height: "高度",
        resolutionRatio: "解析度",
        inputResolutionRatioName: "請輸入解析度名稱",
        sort: "排序",
        personal: "個人",
        system: "系統",
        type: "類型",
        systemDefaultSettingUneditable: "系統預設設定不可編輯!",
        systemDefaultSettingUnDeletable: "系統預設設定不可刪除!",
        newz: "新增",
        total: "共",
        totalNum: "條",
        strategyName: "策略名稱",
        associatedTerminalNum: "關聯終端數量",
        createTime: "建立時間",
        pleaseSelectStrategy: "請選擇策略！",
        onlySelectOneData: "只能選擇一筆數據！",
        downloadStrategy: "下載策略",
        inputStrategyName: "請輸入策略名稱",
        luminanceControl: "亮度控制",
        volumeStrategy: "音量策略",
        saveSuccess: "儲存成功",
        screenAngle: "螢幕旋轉(°)",
        startTime: "開始時間",
        endTime: "結束時間",
        repeat: "重複",
        monday: "週一",
        tuesday: "週二",
        wednesday: "週三",
        thursday: "週四",
        friday: "週五",
        saturday: "週六",
        sunday: "週日",
        everyday: "每天",
        downloadSpeed: "下載速度",
        inputDownloadSpeed: "請輸入下載速度",
        operator: "操作",
        pleaseSelectDeleteData: "請選擇要刪除的數據！",
        confirmBatchDelete: "確認批次刪除嗎？",
        pleaseInputName: "請輸入名稱",
        detailSetting: "詳細設定",
        weekPlan: "週計畫",
        specialDateSetting: "特殊日期設定",
        weekdayInfo: "星期為必填項!",
        volumeInfo: "音量為必填項!",
        timeError: "時間選擇錯誤!",
        editSuccess: "編輯操作成功！",
        addSuccess: "新增操作成功！",
        addSpecialPlan: "新增特殊策略計畫",
        downloadSpeedInfo: "下載速度:(0代表禁止下載)",
        pleaseSelectStartTime: "請選擇開始時間",
        pleaseSelectEndTime: "請選擇結束時間",
        luminanceError: "請輸入正確的亮度值！",
        defaultLuminance: "預設亮度",
        luminance: "亮度大小",
        defaultLuminanceInfo: "預設亮度(100表示最亮,0表示最暗)",
        volume: "音量",
        saveLuminance: "儲存亮度",
        changeSuccess: "變更成功！",
        changeNetwork: "更換網路",
        netName: "網路名稱",
        nameempty: "網路名稱不能為空",
        currentNetwork: "當前網路",
        ipAddress: "IP位址",
        dailyMode: "每天模式",
        weeklyMode: "每週模式",
        turnOnTime: "開機時間",
        turnOffTime: "關機時間",
        startSleep: "開始休眠",
        endSleep: "結束休眠",
        batchDelInfo: "確定刪除選取項嗎？",
        timeCannotBeEmpty: "時間不能為空!",
        startUp: "開機",
        shutDown: "關機",
        volumeSize: "音量大小",
        defaultVolume: "預設音量(100表示最大,0表示靜音)",
        chooseStartTime: "請選擇開始時間",
        chooseEndTime: "請選擇結束時間",
        saveVolume: "儲存音量",
        screenRotationUnSaved: "螢幕旋轉未儲存",
        volumeSettingUnSaved: "音量設定未儲存",
        luminanceSettingUnSaved: "亮度設定未儲存",
        confirmClosePopup: "確認關閉此彈窗嗎?",
        volumeSettingSuccess: "音量修改成功",
        luminanceSettingSuccess: "亮度修改成功",
        advancedSettingUnSaved: "進階設定未儲存",
        settingTitle: "終端設定",
        volumeSetting: "音量設定",
        luminanceSetting: "亮度設定",
        downloadSetting: "下載設定",
        sleepSetting: "休眠設定",
        onOffSetting: "定時開關機",
        screenRotation: "螢幕旋轉",
        namingError: "命名錯誤，檔案名稱中不可有空格！",
        deleteSuccess: "刪除成功",
        deleteFolder: "刪除資料夾",
        pleaseInputDeviceName: "請輸入設備名稱",
        pleaseInputDeviceId: "請輸入設備id",
        discoverDevice: "發現設備",
        deviceId: "設備ID",
        bound: "已綁定",
        bind: "綁定",
        noDevice: "暫無設備",
        refresh: "重新整理",
        manualAdd: "手動新增",
        deviceGroup: "設備分類",
        pleaseSelectGroup: "請選擇分組！",
        deviceName: "設備名稱",
        goAdd: "前往新增",
        close: "關閉",
        bindCountInsufficient: "可綁定數量不足，請升級設備數量後新增！",
        displayNumber: "顯示編號",
        groupName: "分組名稱",
        pleaseSelectGroupName: "請填寫分組名稱！",
        moveGroup: "移動分組",
        longitude: "經度",
        latitude: "緯度",
        nationality: "國籍",
        province: "省",
        city: "市",
        county: "縣",
        outNetIp: "外網ip",
        inNetIp: "內網ip",
        companyName: "企業名稱",
        Info: "詳情",
        android: "安卓",
        win: "win",
        osVersion: "系統版本",
        softwareVersion: "軟體版本",
        diskSize: "磁碟大小",
        useSize: "已用大小",
        macAddr: "MAC位址",
        longitudeLatitudeInfo: "經緯度必須同時為空或者不為空!",
        terminalName: "終端名稱",
        terminalGroup: "終端分組",
        reportJournal: "是否上報",
        systemVersion: "系統版本",
        storageSpace: "儲存空間",
        resolution: "解析度",
        runningMemory: "執行記憶體",
        model: "型號",
        registerStatus: "註冊狀態",
        password: "密碼",
        passwordInfo: "請輸入6到18位單字或數字!",
        group: "分組",
        address: "地址",
        remark: "備註",
        renewalPeriod: "續費週期",
        money: "費用",
        latitudeInfo: "請輸入正確的緯度!",
        totalPayment: "總金額",
        longitudeInfo: "請輸入正確的經度!",
        setMeal: "套餐",
        number: "數量",
        programName: "節目名稱",
        playStatus: "播放狀態",
        playType: "播放方式",
        play: "播放",
        pause: "暫停",
        playTime: "播放時間",
        programDeleted: "節目已刪除",
        playSuccess: "節目已安排播放",
        pauseSuccess: "暫停成功",
        playCycle: "輪播",
        playInsert: "插播",
        withdrawSuccess: "撤回成功",
        withdrawInfo: "請先選擇撤回的節目！",
        programBelong: "所屬節目",
        checkAll: "全選",
        batchDel: "批次刪除",
        delConfirm: "確定刪除選取項嗎？",
        check: "選取",
        noProgram: "暫無節目",
        details: "詳情",
        screenshotFail: "截圖失敗",
        policyName: "策略名稱",
        terminalNum: "關聯終端數量",
        powerStrategy: "電源策略",
        pleaseSelectDepartment: "請選擇部門！",
        screenshotControl: "截圖控制",
        未激活: "未啟用",
        已激活: "已啟用",
        未绑定: "未綁定",
        已绑定: "已綁定",
    },
    programManage: {
        programList: "節目列表",
        publishProgram: "節目發布追溯",
        week1: "週一",
        week2: "週二",
        week3: "週三",
        week4: "週四",
        week5: "週五",
        week6: "週六",
        week7: "週日",
        monday: "星期一",
        tuesday: "星期二",
        wednesday: "星期三",
        thursday: "星期四",
        friday: "星期五",
        saturday: "星期六",
        sunday: "星期日",
        name: "名稱",
        preview: "預覽",
        playDeviceNum: "播放設備數",
        copyDeviceCode: "點擊複製",
        osType: "系統類型",
        playDate: "播放日期",
        playWeek: "播放週",
        everyday: "每天",
        start: "起",
        end: "迄",
        playOperateStatusStr: "發布狀態",
        playDevice: "播放設備",
        downloadView: "下載查看",
        publisher: "發布者",
        publishTime: "發布時間",
        operation: "操作",
        add: "新增",
        groupName: "分組名稱",
        selectDevice: "選擇終端",
        searchDevice: "搜尋終端",
        pleaseFillGroupName: "請填寫分組名稱！",
        remarkInfo: "備註",
        compile: "編輯",
        withdrawConfirm: "確認撤回該節目？",
        confirm: "確定",
        cancel: "取消",
        withdraw: "撤回",
        batchWithdraw: "批次撤回",
        batchPublish: "批次發布",
        batchDelete: "批次刪除",
        batchOperation: "批次操作",
        notUse: "未使用",
        notChecked: "未審核",
        notPass: "未通過",
        delete: "刪除",
        publishTextLeft: "已發布",
        offTextLeft: "已暫停",
        pleaseSelectProgramToMove: "請選擇要轉移的節目！",
        pause: "暫停",
        pauseConfirm: "確定暫停嗎？",
        play: "播放",
        downloadUdisk: "下載USB隨身碟",
        deviceList: "設備列表",
        groupSelection: "分組選擇",
        operationSuccess: "操作成功",
        deleteSuccess: "刪除成功",
        selectDate: "選擇日期",
        publishStatus: "發布狀態",
        checkStatus: "審核狀態",
        waitAuditing: "待審核",
        auditPass: "審核通過",
        auditRefuse: "審核拒絕",
        all: "全部",
        playStatus: "播放中",
        playStatust: "播放狀態",
        pauseStatus: "已暫停",
        notStartStatus: "未開始",
        resolutionratio: "解析度",
        totalNum: "條",
        programName: "節目名稱",
        playStartTime: "播放開始時間",
        playEndTime: "播放結束時間",
        createTime: "建立時間",
        nationality: "國籍",
        province: "省份",
        city: "城市",
        county: "區縣",
        address: "地址",
        ip: "IP位址",
        location: "位置",
        log: "日誌",
        pleaseFillProgramName: "請填寫節目名稱！",
        selectGroup: "選擇分組",
        startTime: "開始時間",
        endTime: "結束時間",
        publishCycle: "發布週期",
        publishDeviceNum: "發布設備數",
        pleaseSelectRecord: "請選擇記錄",
        deviceName: "終端名稱",
        deviceId: "終端設備ID",
        deviceGroupIdName: "所在分組",
        notClassified: "未分類",
        osTypeStr: "終端系統",
        storageSpace: "儲存空間",
        onLineStatus: "線上狀態",
        onLine: "線上",
        offLine: "離線",
        sleep: "休眠",
        unknown: "未知",
        registerStatus: "註冊狀態",
        trialPeriod: "試用期",
        notActive: "未啟用",
        active: "已啟用",
        parameterError: "參數有誤!",
        pleaseSelectProgram: "請選擇節目!",
        pleaseSelectProgramEdit: "請選擇編輯的節目!",
        confirmWithdrawSelectedProgram: "確認撤回所選節目？",
        withdrawSuccess: "撤回成功",
        allPrograms: "全部節目",
        defaultGroup: "預設分組",
        cannotShareEmptyProgram: "無法分享空節目！",
        onlyShareYourProgram: "只能分享您建立的節目!",
        pleaseSelectProgramEditPublishTime: "請選擇編輯完發布時間的節目!",
        pleaseSelectDevice: "請選擇設備!",
        programDetail: "節目詳情",
        errorReason: "錯誤原因",
        availableStorageSpaceInsufficient: "可用儲存空間不足",
        partialDeviceReleaseFailure: "部分設備發布失敗",
        allDeviceReleaseSuccess: "所有設備發布成功",
        partialDeviceReleaseSuccess: "部分設備發布成功",
        allGroup: "所有分組",
        allProgram: "所有節目",
        unGrouped: "未分組",
        replaceProgram: "替換節目",
        replaceProgramTip: "新發布的節目將替換播放端原有下發的節目數據！",
        screen: "單雙螢幕",
        singleScreen: "單螢幕",
        doubleScreen: "雙螢幕",
        playSetting: "播放設定",
        batchPlaySetting: "批次設定播放時間",
        individualPlaySetting: "逐個設定播放時間",
        playTime: "播放時間",
        daily: "每天",
        weekdays: "週一至週五",
        monthly: "當月",
        advancedSetting: "進階設定",
        playProgram: "播放節目",
        searchProgram: "請輸入關鍵字",
        shareAddressNotExist: "連結位址不存在，請重試",
        copySuccess: "複製成功",
        shareLink: "分享連結",
        publish: "發布",
        noResource: "暫無資源",
        single: "單螢幕",
        double: "雙螢幕",
        time: "時間",
        associatedTerminalNum: "關聯終端數量",
        default: "預設",
        moveGroup: "移動分組",
        pleaseSelectGroup: "請填寫分組名稱！",
        copy: "複製",
        FUBEN: "副本",
        nameempty: "名稱不能為空",
        whitespace: "命名錯誤，檔案名稱中不可有空格！",
        programWhitespace: "命名錯誤，節目名稱中不可以有空格！",
        pleaseSelectResolution: "請選擇解析度！",
        dataError: "數據有誤！",
        createProgram: "新增節目",
        directCreate: "直接建立",
        myTemplate: "我的模板",
        use: "使用",
        free: "免費",
        loadMore: "載入更多",
        confirmDelete: "確認刪除",
        deleteGroup: "刪除分組",
        notPublished: "未發布",
        notPassed: "未通過",
        notUsed: "未使用",
        confirmDeleteSelectedProgram: "確認刪除所選節目？",
        companyName: "企業名稱",
        programCannotDownload: "該節目不可下載！",
        publishMaterial: "發布素材",
        playMaterial: "播放素材",
        pleaseInputMaterialName: "請輸入素材名稱",
        size: "大小",
        pleaseInputDeviceName: "請輸入設備名稱",
        item: "條",
        allMaterial: "全部素材",
        allDevices: "全部設備",
        "saveSuccess": "儲存成功",
        "savefaill": "儲存失敗",
        "playMode": "播放方式",
        "cyclePlay": "輪播",
        "insertPlay": "插播",
        "noData": "暫無數據",
        "Add": "新增",
        "replace": "替換",
        "repeat": "重複",
        "start01": "開始",
        "end01": "結束",
        "startDate": "開始日期",
        "endDate": "結束日期",
        "useNow": "立即使用",
        "fillStartEndTimeFirst": "請填寫完開始與結束時間再新增",
        "fillFullPlayTime": "請填寫完整播放時間",
        "fillCorrectPlayTime": "請填寫正確的播放時間段",
        "sDateAndEDateBothEmptyOrFilled": "開始日期與結束日期必須同時為空或者不為空"
    },
    source: {
        addResource: "資源新增",
        width: "寬度",
        height: "高度",
        size: "大小(KB)",
        name: "名稱",
        pleaseInputResourceName: "請輸入資源名稱！",
        addToGroup: "新增至分組",
        remark: "備註",
        promptFgIllustrate: "插畫",
        promptFgRealisticPhoto: "寫實照片",
        promptFgSimplisticDrawing: "簡筆畫",
        promptFgChineseStyle: "國風",
        promptFgPixelArt: "像素風",
        noModel: "暫無模型，請聯繫管理員！",
        getModelFailed: "取得模型失敗，請稍後重試！或者聯繫管理員！",
        createImagePrompt: "正在生成圖片，請稍後關閉！",
        promptEmpty: "請輸入提示詞",
        dpiEmpty: "請選擇圖片比例！",
        fgEmpty: "請選擇風格！",
        style: "風格",
        idEmpty: "圖片id不能為空",
        exist: "該圖片已存在素材中",
        addSuccess: "新增素材成功",
        saveError: "儲存圖片失敗，請稍後重試！",
        delSuccess: "刪除成功",
        generateImage: "文生圖",
        generateImagePlaceholder: '請輸入你想生成的圖片，如：一隻蝴蝶在花海中翩翩起舞',
        aiExpand: "智能擴寫",
        negativePrompt: "反向提示詞",
        negativePromptTooltip: "用於明確排除用戶不希望出現在輸出中的內容或特徵",
        imageRatio: "圖片比例",
        generateImageBtn: "立即生成",
        shengchengjieguo: "生成結果",
        generateImageLoadingTip: "生成中，請勿重複點擊或關閉...",
        Tooltip: "快來 AI 你的創意吧",
        saveToMaterial: "儲存到素材",
        publish: "立即發布",
        download: "下載",
        generateHistory: "生成歷史",
        hide: "收起",
        cancel: "取消",
        useExpand: "使用擴寫",
        all: "全部",
        delete: "刪除",
        loadMore: "載入更多",
        aiTip: "內容由人工智慧模型生成，不代表平台的觀點、立場或態度，請合理合規地使用 AI 內容",
        operationSuccess: "操作成功",
        moveGroup: "移動分組",
        groupName: "分組名稱",
        pleaseSelectGroup: "請選擇分組名稱！",
        shenhe: "審核",
        shenheStatus: "審核狀態",
        shenheSuccess: "審核通過",
        shenheRefuse: "審核拒絕",
        pleaseSelectShenheStatus: "請選擇審核狀態！",
        shenheRemark: "審核備註",
        pleaseInputShenheRemark: "請輸入審核備註！",
        pleaseInputFileName: "請輸入檔案名稱！",
        whitespace: "命名錯誤，檔案名稱中不可有空格！",
        dataError: "數據有誤！",
        confirmDelete: "確認刪除",
        confirm: "確定",
        deleteFolder: "刪除資料夾",
        add: "新增",
        edit: "編輯",
        fileName: "檔案名稱",
        group: "分組",
        resolution: "解析度",
        type: "類型",
        image: "圖片",
        music: "音樂",
        video: "影片",
        uploadTime: "上傳時間",
        uploadUser: "上傳人",
        checkTime: "審核時間",
        checkUser: "審核人",
    },
    setting: {
        nameempty: "名稱不能為空",
        heightempty: "高度不能為空",
        widthempty: "寬度不能為空",
        resolutionratio: "解析度",
        name: "名稱",
        opteration: "操作",
        compile: "編輯",
        delete: "刪除",
        newz: "新增",
        compileratio: "編輯解析度",
        sheizhifenbianlvmingcheng: "設定解析度名稱",
        shezhigaodu: "設定高度",
        shezhikuandu: "設定寬度",
        xinzengfenbianlv: "新增解析度",
        bianma: "編碼",
        bianjizhongduanmingcheng: "編輯終端名稱",
        xinzengzhongduan: "新增終端",
        selectPrimaryColor: '選擇主題顏色',
        fullScreen: '全螢幕',
        exitFullScreen: '退出全螢幕',
    },
    tabs: {
        refresh: '重新整理',
        refreshAll: '重新整理全部',
        close: '關閉',
        closeOthers: '關閉其他',
        closeAll: '關閉所有',
        closeLeft: '關閉左側',
        closeRight: '關閉右側',
    },
    errorPage: {
        needLogin: '您尚未登入！',
        pageNotFound: '您訪問的頁面不存在！',
        redirectTo: '跳轉到',
        orReturn: '或者返回',
        previousStep: '上一步',
    },
    headerUs: {
        systemNotice: "系統通知",
        allNotices: "全部通知",
        viewAllMessages: "查看全部訊息",
        contactUs: "聯繫我們",
        operationSuccess: "操作成功！",
        leaveMessage: "我要留言",
        messageTitle: "標題",
        messageTitleTip: "請輸入標題！",
        messageContentTip: "150字以內",
        submit: "提交",
        markAsRead: "標為已讀",
        success: "操作成功！"
    },
    material: {
        allMaterial: "全部素材",
        defaultGroup: "預設分組",
        auditStatus: "審核狀態",
        auditPassed: "審核通過",
        auditRejected: "審核拒絕",
        pendingAudit: "待審核",
        all: "全部",
        operateSuccess: "操作成功！",
        pleaseSelectMaterial: "請選擇素材！",
        moveGroup: "移動分組",
        pleaseSelectGroup: "請選擇分組！",
        batchPublish: "批次發布",
        batchRecall: "批次撤回",
        batchDelete: "批次刪除",
        materialList: "素材列表",
        uploadMaterial: "上傳素材",
        materialType: "素材類型",
        pleaseInputMaterialName: "請輸入素材名稱",
        selectAll: "全選",
        confirmDeleteSelectedMaterial: "確認刪除選取素材嗎？",
        deleteSuccess: "刪除成功",
        delete: "刪除",
        publish: "發布",
        recall: "撤回",
        confirmRecallSelectedMaterial: "確認撤回選取素材嗎？",
        pleaseSelectMaterialGroup: "請選擇素材分組！",
        recallSuccess: "撤回成功",
        publishSuccess: "發布成功",
        batchOperate: "批次操作",
        item: "條",
        confirmDelete: "確認刪除嗎？",
        edit: "編輯",
        confirmRecall: "確認撤回嗎？",
        unaudited: "未審核",
        notPassed: "未通過",
        operate: "操作",
        resolution: "解析度",
        none: "無",
        confirm: '確定',
        cancel: '取消',
        AICreation: "AI創作",
    },
    uploadFile: {
        operationSuccess: "操作成功",
        uploadFile: "上傳管理",
        uploadSuccess: "上傳成功",
        uploadCompleted: "上傳完成",
        uploadFail: "上傳失敗",
        ConversionFailed: "轉換失敗！",
        loading: "努力載入中...",
        beQueuing: "排隊中...",
        Uploading: "上傳中...",
        ConversionIng: "轉換中...",
        ConventionalResources: "常規資源",
        DocumentResources: "文件資源",
        complete: "完成",
        upload: "上傳",
        fileSizeWraning01: "素材大小超過",
        fileSizeWraning02: "請修改後重新上傳！",
        fileIsEmpty: "檔案為空",
        uploadFileTip: "不支援的檔案格式",
        unablePreview: "未成功新增到素材庫，無法預覽",
        confirmDelete: "確認刪除嗎？",
        deleteSuccess: "刪除成功",
        delete: "刪除",
        confirm: "確定",
        preview: "預覽",
        close: "關閉",
        cancel: "取消",
        fileType: "檔案類型",
        fileSize: "檔案大小",
        conversionProgress: "轉換進度",
        progress: "進度",
        image: "圖片",
        video: "影片",
        audio: "音樂",
        limitTip01: "一次上傳",
        limitTip02: "個檔案",
        okTip: "正在上傳素材，請稍後關閉！",
        usableSize: '可用容量',
        sizeUnableTip: "當前可用儲存空間不足，請及時清理無用的素材節省空間或聯繫經銷商擴充容量。",
        view: "查看詳情",
        fileName: "檔案名稱",
    },
    template: {
        inputPlaceholder: '請輸入',
        selectPlaceholder: '請選擇',
        noAuths: "暫無權限，請聯繫管理員",
        operationSuccess: "操作成功",
        total: "共",
        totalNum: "條",
        dan: "單",
        shaung: "雙",
        pleaseSelectGroup: "請選擇分組",
        preview: "預覽",
        free: "免費",
        use: "使用",
        dpi: '解析度',
        delete: "刪除",
        confirmDelete: "確認刪除",
        confirmDeleteSelectedTemplate: "確認刪除此模板嗎",
        push: "發布",
        pushConfirm: "確認發布到公開模板嗎",
        pushRemovalConfirm: "確認從公開模板下架嗎",
        templateOrderRecord: "模板訂單記錄",
        unpublished: "未發布",
        auditing: "審核中",
        publishRejected: "發布拒絕",
        publishSuccess: "發布成功",
        offShelf: "下架",
        公共模版: "公開模板",
        我的模板: "我的模板",
        共享记录: "共享記錄",
        name: "名稱",
        pubdate: "發布時間",
        keySeachTip: "請輸入關鍵字",
        allGroup: "全部分組",
        add: "新增",
        edit: "編輯",
        programName: "節目名稱",
        selectGroup: "選擇分組",
    },
    checkManage: {
        total: "共",
        totalNum: "條",
        operationSuccess: "操作成功",
        checkUserLogs: "審核記錄（操作員）",
        checkLogs: "審核記錄（審核員）",
        sourceCheck: "素材審核",
        programCheck: "節目審核",
        checkAll: "全選",
        auditPass: "審核通過",
        auditRefuse: "審核拒絕",
        auditPass01: "通過",
        auditRefuse01: "拒絕",
        auditRefuse02: "拒絕審核",
        auditor: "審核人",
        agentUserName: "發布人",
        interrogationTime: "提審時間",
        checkTime: "審核時間",
        checkName: "審核名稱",
        checkType: "審核類別",
        checkIp: "提審IP位址",
        checkReason: "留言",
        checkStatus: "操作內容",
        rangePicker: "審核日期",
        keyWord: "關鍵字",
        all: "全部",
        program: '節目',
        material: '素材',
        dan: "單",
        shaung: "雙",
        pleaseSelectProgram: "請選擇節目!",
        pleaseSelectMaterial: "請選擇素材！",
        preview: "預覽",
        dpi: '解析度',
        auditRefuseTip: "請輸入拒絕原因",
        unreviewed: "未審核",
        notPassed: "未通過",
        notUsed: "未使用",
        edit: "編輯",
        none: "無",
        name: "名稱",
        size: "大小",
        type: "類型",
        uploadTime: "上傳時間",
        uploadUser: "上傳人",
        checkUser: "審核人",
        image: "圖片",
        music: "音樂",
        video: "影片",
    },
    systemSet: {
        total: "共",
        totalNum: "條",
        inputPlaceholder: '請輸入',
        selectPlaceholder: '請選擇',
        userList: "組織成員",
        roleList: "角色權限",
        department: "組織架構",
        diskInfo: "儲存空間",
        approveSet: "內容審批",
        logList: "日誌管理",
        name: "姓名",
        account: "帳號",
        userName: "用戶姓名",
        phoneNumber: "手機號",
        role: "角色",
        createTime: "建立時間",
        operation: "操作",
        edit: "編輯",
        delete: "刪除",
        addNew: "新增",
        add: "新增",
        resetPassword: "重設密碼",
        confirmDelete: "確定刪除",
        departmentOrganization: "部門機構",
        addNewUser: "新增用戶",
        pleaseEnterUserName: "請輸入用戶姓名",
        confirmPasswordNotMatch: "確認密碼與密碼輸入的不同!",
        operationSuccess: "操作成功！",
        userNickname: "用戶名稱",
        pleaseEnterUserNickname: "請輸入用戶名稱",
        userNicknameRequired: "用戶名稱不能為空！",
        password: "密碼",
        pleaseEnterPassword: "請輸入密碼",
        passwordRequired: "密碼不能為空！",
        passwordTip: "您的密碼安全性太低（密碼中必須包含大小寫字母、數字、特殊字元任意3種且長度在8",
        confirmPassword: "確認密碼",
        pleaseEnterPhoneNumber: "請輸入手機號",
        phoneNumberRequired: "手機號不能為空！",
        phoneNumberFormatError: "請輸入正確的手機號！",
        roleRequired: "角色不能為空！",
        required: "不能為空！",
        departmentName: "部門",
        modifyPassword: "修改密碼",
        newPassword: "新密碼",
        pleaseEnterNewPassword: "請輸入新密碼",
        pwdMessage: "密碼長度8~20字元，不能包含空格且必須包含大小寫字母、數字、特殊字元其中3種",
        all: "全部",
        noAuths: "暫無權限，請聯繫管理員",
        departmentName01: "部門名稱",
        image: "圖片",
        music: "音樂",
        video: "影片",
        buySize: "購買數量",
        totalMoney: "付費金額",
        buycreateTime: "購買時間",
        endTime: "到期時間",
        buyTypeStr: "訂單類型",
        sourceCheck: "素材審核",
        programCheck: "節目審核",
        programName: "節目名稱",
        diskExpansion: "建議在使用過程中及時清理過期/不用的素材，以保證系統的可用容量。若您有更大空間的需求，您可以聯繫您的設備供應商取得雲端儲存空間的容量擴充服務。此服務可能會產生費用，具體請以經銷商的資訊為準。",
        selectPermission: "請選擇權限",
        checkPermission: "請勾選權限",
        addRole: "新增角色",
        enterRoleName: "請輸入角色名稱",
        roleName: "角色名稱",
        roleNameRequired: "角色名稱不能為空！",
        remark: "備註",
        enterRemark: "請輸入備註",
        permissionSetting: "權限設定",
        deleteSuccess: "刪除成功！",
        confirmToDelete: "確定刪除嗎？",
        orgName: "機構名稱",
        orgNameRequired: "機構名稱不能為空！",
        orgRemark: "機構備註",
        enterOrgRemark: "請輸入機構備註",
        capacityUsage: "容量使用狀況",
        usedCapacity: "已用容量",
        totalCapacity: "總容量",
        remainingCapacity: "剩餘容量",
        capacityExpansion: "容量擴充",
        enable: "開啟",
        disable: "關閉",
        userName01: "用戶名",
        loginTime: "登入時間",
        ipAddress: "IP位址",
        loginResult: "登入結果",
        selectDate: "選擇日期",
        enterDate: "請選擇日期",
        selectStartTime: "請選擇開始時間",
        selectEndTime: "請選擇結束時間",
        enterUserName: "請輸入用戶名",
        userCount: "用戶數",
        roleDesc: "角色描述",
        roleAuthorization: "角色授權",
        success: "成功",
        failure: "失敗",
        time: "時間",
        operationContent: "操作內容",
        playCount: "播放次數",
        playDuration: "播放時長",
        selectDevice: "選擇設備",
        enterProgramName: "請輸入節目名稱",
        serialNumber: "序號",
        publishContentName: "發布內容名稱",
        playMode: "播放方式",
        cyclePlay: "輪播",
        insertPlay: "插播",
        paddingPlay: "墊播",
        playDeviceId: "播放設備ID",
        playDeviceName: "播放設備名稱",
        publishTime: "發布時間",
        downloadStatus: "下載狀態",
        notDownloaded: "未下載",
        downloading: "下載中",
        downloadSucceeded: "下載成功",
        downloadFailed: "下載失敗",
        enterPublishContentName: "請輸入發布內容名稱",
        terminalId: "終端ID",
        belongOrg: "所屬機構",
        reportTime: "上報時間",
        reportIp: "上報IP",
        logInfo: "日誌資訊",
        details: "詳情",
        confirmDeletion: "確定要刪除嗎？",
        logDetails: "日誌詳情",
        download: "下載",
        deptOrg: "部門機構",
        query: "查詢",
        queryByTerminalId: "按終端ID查詢",
        batchDeleteLogs: "批次刪除日誌",
        customTimeDeleteLogs: "自定義時間刪除日誌",
        selectTimeRangeFirst: "請先選擇時間範圍",
        deleteAllDeviceLogsIfEmpty: "若不填寫設備ID，則預設刪除全部設備的日誌",
        enterDeviceIdToDeleteLogs: "請輸入要刪除日誌的設備ID",
        confirmDeleteAction: "確定刪除",
        selectDeleteRangeFirst: "請先選擇刪除範圍",
        networkConnectionFailed: "網路連線失敗",
        playLog: "播放日誌",
        publishLog: "發布日誌",
        errorLog: "錯誤日誌",
        operationLog: "操作日誌",
        fileLog: "檔案日誌",
        userOperateLog: "登入日誌",
    },
    "userManual": {
        "userManual": "使用者手冊",
        "noData": "暫無資料"
    },
    "systemNotice": {
        "systemNotice": "系統通知",
        "noData": "暫無資料",
        "total": "共",
        "totalNum": "筆",
        "markAllRead": "全部已讀",
        "deleteAll": "全部刪除",
        "all": "全部",
        "unread": "未讀",
        "read": "已讀",
        "type": "類型",
        "content": "內容",
        "date": "日期",
        "status": "狀態",
        "confirmDelete": "確定刪除嗎？",
        "confirm": "確定",
        "cancel": "取消",
        "delete": "刪除"
    }
};